import { cn } from "@repo/shared/utils";
import type { ReviewStatus } from "@repo/types";
import { Button } from "@repo/ui/components/Base/Button";
import { Label } from "@repo/ui/components/Base/Label";

export interface ApprovalButtonsProps {
  disabled?: boolean;
  label?: string;
  value?: ReviewStatus;
  onValueChange?: (value: ReviewStatus) => void;
  containerStyle?: string;
  labelStyle?: string;
  showDeferred?: boolean;
  approvedText?: string;
  rejectedText?: string;
  deferredText?: string;
}

export const ApprovalButtons = ({
  disabled,
  label,
  value,
  onValueChange,
  containerStyle,
  labelStyle,
  showDeferred = true,
  approvedText = "The motion carries",
  rejectedText = "The motion fails",
  deferredText = "The motion was deferred",
}: ApprovalButtonsProps) => {
  const update = (newValue: ReviewStatus) => {
    if (newValue === value) newValue = "pending";
    onValueChange?.(newValue);
  };

  return (
    <div className={cn("flex flex-col gap-y-1 mt-1.5", containerStyle)}>
      {label && <Label className={labelStyle} label={label} />}

      <div className="flex flex-row gap-x-2">
        <Button
          type="button"
          disabled={disabled}
          className={cn(
            "h-8 border-[2px] border-tertiary",
            value === "approved"
              ? "bg-tertiary hover:bg-tertiary/90"
              : "text-tertiary bg-transparent hover:bg-transparent"
          )}
          onClick={() => update("approved")}
        >
          Approved
        </Button>
        <Button
          type="button"
          disabled={disabled}
          className={cn(
            "h-8 border-[2px] border-destructive",
            value === "rejected"
              ? "bg-destructive hover:bg-destructive/90"
              : "text-destructive bg-transparent hover:bg-transparent"
          )}
          onClick={() => update("rejected")}
        >
          Rejected
        </Button>
        {showDeferred && (
          <Button
            type="button"
            disabled={disabled}
            className={cn(
              "h-8 border-[2px] border-primary",
              value === "deferred"
                ? "bg-primary hover:bg-primary/90"
                : "text-primary bg-transparent hover:bg-transparent"
            )}
            onClick={() => update("deferred")}
          >
            Deferred
          </Button>
        )}
      </div>
      {value === "approved" ? (
        <p className="font-bold text-tertiary">{approvedText}</p>
      ) : value === "rejected" ? (
        <p className="font-bold text-destructive">{rejectedText}</p>
      ) : value === "deferred" ? (
        <p className="font-bold text-primary">{deferredText}</p>
      ) : null}
    </div>
  );
};
